import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BackgroundColors } from '@picsart/design-system/foundation/colors';
import { Breakpoints } from '@picsart/design-system/foundation/responsive';
import { BREAKPOINTS } from '@/consts/breakpoints';

const useStyles = createUseStyles(
  {
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      padding: [0, Spacings.s16],
      [`@media (max-width: ${Breakpoints.xs}px)`]: {
        padding: [0, Spacings.s12],
      },
    },
    wrapper: {
      padding: [0, Spacings.s32],
      [`@media (max-width: ${Breakpoints.xl}px)`]: {
        padding: [0, Spacings.s24],
      },
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      // Desktop size
      height: 400,
      // Mobile size with border
      [`@media (max-width: ${Breakpoints.sm}px)`]: {
        width: 256,
        height: 440,
        gap: Spacings.s24,
        borderRadius: CornerRadius.r16,
        border: [1, 'solid', BackgroundColors.tint2],
      },
      // Small mobile - full width
      [`@media (max-width: ${Breakpoints.xs}px)`]: {
        width: '100%',
        maxWidth: 280,
        height: 'auto',
        minHeight: 360,
        gap: Spacings.s16,
        padding: Spacings.s16,
        borderRadius: CornerRadius.r12,
      },
    },
    // Scale up LoadingCard on desktop for better readability
    loadingCard: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s8,
      transformOrigin: 'center center',
      '& > figure': {
        height: 80,
        width: 80,
      },
      [`@media (max-width: ${Breakpoints.sm}px)`]: {
        transform: 'scale(1)',
      },
    },
    // Compact variant for inline card display (Generations tab): fills the
    // square card; the inner content is scaled down in CSS to fit it.
    compactWrapper: {
      width: '100%',
      height: '100%',
      padding: Spacings.s12,
      overflow: 'hidden',
    },
    compactFitBox: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    // The content is laid out at the fixed FIT_REF_WIDTH and scaled down per
    // breakpoint to fit the square grid cell. (A previous CSS-trig auto-fit,
    // `scale(tan(atan2(100cqw, …)))`, computed a negative value in some
    // WebViews and rendered the whole card upside-down — see the flip bug.)
    compactContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      gap: Spacings.s8,
      flexShrink: 0,
      maxWidth: '100%',
      transformOrigin: 'center center',
      transform: 'scale(0.9)',
      [`@media (max-width: ${Breakpoints.xs}px)`]: {
        transform: 'scale(0.78)',
      },
      [`@media (max-width: ${BREAKPOINTS.tinyMobile}px)`]: {
        transform: 'scale(0.64)',
      },
    },
    compactProgress: {
      width: '85%',
      maxWidth: 180,
      [`@media (max-width: ${BREAKPOINTS.tinyMobile}px)`]: {
        width: '75%',
      },
    },
  },
  { name: 'generation-loading' }
);

export default useStyles;
